import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { SIZES } from '../Common/constants';

// components
import SearchIcon from 'dibs-vg/dist/react/magnifying-glass';
import { StyledButton } from '../Common/Button/StyledButton';

// styles
import styles from './main.scss';

const { small, medium, large } = SIZES;

type ButtonProps = {
    dataTn: string;
    size: typeof small | typeof medium | typeof large;
    disabled?: boolean;
    hideClearButton?: boolean;
};

export const RightSearchButton: FunctionComponent<ButtonProps> = ({
    dataTn,
    size,
    disabled = false,
    hideClearButton = true,
}) => {
    // default to medium size
    let sizeSearch = styles.mediumSearch;
    if (size === 'small') {
        sizeSearch = styles.smallSearch;
    } else if (size === 'large') {
        sizeSearch = styles.largeSearch;
    }
    const searchButtonClasses = classnames({
        [styles.defaultSearch]: !size,
        [sizeSearch]: !!size,
        [styles.fullyTransparent]: hideClearButton,
        [styles.noClick]: hideClearButton,
        [styles.whiteFill]: !hideClearButton,
    });

    const buttonProps = {
        className: searchButtonClasses,
        dataTn,
        disabled,
        isPrimary: !hideClearButton,
        tabIndex: -1,
    };

    return (
        <StyledButton type="submit" {...buttonProps}>
            <SearchIcon />
        </StyledButton>
    );
};
